import { useEffect, useRef, useState } from "react";
import { Col } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import noImage from "../../../src/assests/tipperUiSection/toptipper-logo.png";
import { eyeIcon } from "../../assests/tipperUiSection/Icons/icons";
import oops from "../../assests/tipperUiSection/oops.svg";
import ReactSelectField from "../../components/reactSelectBox/ReactSelectField";
import ReactSkeleton from "../../components/reactSkeleton";
import ThemeButton from "../../components/theme/themeButton";
import TipperLayout from "../../components/tipperUiSectionLayout";
import ConfirmationModal from "../../components/tipperUiSectionLayout/modal/ConfirmationModal";
import PaymentFooter from "../../components/tippingUiSection/footer";
import PaymentHeader from "../../components/tippingUiSection/header";
import {
  getCopyLink,
  getEmployeeListApi,
  getOldTippingUrlApi,
  getPaymentData,
  getPropertyListApi,
  getServiceListApi,
  isAllThreeFeaturesUpdate,
  postTipAmountApi,
  submitOrganizationRatingApi,
  setHomeUrl,
  setPrevUrl,
  setReviewUuid,
  setShowCardholderName,
  updateMediaUrl,
  updateSuggestedAmounts,
} from "../../store/slices/paymentSlices";
import { setSessionId } from "../../store/slices/sessionSlice";
import { AppDispatch, RootState } from "../../store/store";
import { calculateFee, createNewSession, handleSetupIntentPayload, notifyBugsnagError, saveTokens, tipAmountForOrgFeesApis, buildOrganizationRatingPayload } from "../../utils/functions";
import Rating from "./rating";
import styles from "./tipperPayment.module.scss";

const TippingPayment = () => {
  const [applicationFee, setApplicationFee] = useState<number | string>(0);
  const [intentData, setIntentData] = useState({ type: "", uuid: "" });
  const [stripeFee, setStripeFee] = useState<number | string>(0);
  const [fieldError, setFieldError] = useState("");
  const [postError, setPostError] = useState("");
  const [addNote, setAddNote] = useState<string>()
  const [tipAmount, setTipAmount] = useState<string>("");
  const [isActive, setIsActive] = useState<number | null>(null);
  const [showSubmitModal, setSubmitModal] = useState(false);
  const [isOrgExist, setIsOrgExist] = useState(true);
  const [propertyListDropdown, setPropertyListDropdown] = useState<{ label: string, value: number }[]>([])
  const [serviceListDropdown, setServiceListDropdown] = useState<{ label: string, value: number }[]>([])
  const [employeeListDropdown, setEmployeeListDropdown] = useState<{ label: string, value: number }[]>([])
  const [selectedProperty, setSelectedProperty] = useState<{ label: string, value: any }>();
  const [selectedService, setSelectedService] = useState<{ label: string, value: any }>()
  const [selectedEmployee, setSelectedEmployee] = useState<{ label: string, value: any }>()
  const [noteError, setNoteError] = useState("");
  const [hasRated, setHasRated] = useState(false);
  const [decodedUuid, setDecodedUuid] = useState<string>("");
  const [decodedType, setDecodedType] = useState<string>("");
  const [orgSuggestedAmounts, setOrgSuggestedAmounts] = useState({
    suggested_amount_1: null,
    suggested_amount_2: null,
    suggested_amount_3: null,
  });
  // Ref kept current on every render so effects can read the latest value
  // without needing orgSuggestedAmounts in their dependency arrays
  const orgSuggestedAmountsRef = useRef(orgSuggestedAmounts);
  orgSuggestedAmountsRef.current = orgSuggestedAmounts;

  const handleSubmitModal = () => setSubmitModal(!showSubmitModal);
  const { token1, token2 }: any = useParams();
  const { pathname } = useLocation();
  // Ignore tracking params like fbclid/utm_* when resolving the QR URL.
  const url = `${window.location.origin}${pathname}`;
  const navigate = useNavigate();
  const { data, isGetLoading, postTipAmount, isEmployee, isProperty, isService, propertyListData, serviceListData, employeeListData, properrtyCacheImg, showCardholderName, review_uuid }: any = useSelector(
    (store: RootState) => store.paymentSlices
  );
  const { sessionId } = useSelector(
    (store: RootState) => store.sessionSlice
  );
  const dispatch = useDispatch<AppDispatch>();

  let getLastParam = pathname.split("/");
  getLastParam = getLastParam.filter((item) => item !== "");
  const isCopy = getLastParam[getLastParam.length - 1] === "c";
  const continueButtonLabelText = 'Continue';
  // const addQuote = `“We must find time to stop and thank the people who make a difference in our lives.” ~John F. Kennedy`;
  const addQuote = '';



  /**
   * handle submit data to make payment
   */
  const handleSubmit = (e: any) => {

    e.preventDefault();
    const regex = /^\d{0,6}(?:\.\d*)?$/;
    if (
      tipAmount !== "" &&
      +tipAmount > 0 &&
      fieldError?.length === 0 &&
      regex.test(tipAmount)
    ) {
      let jwtData: any;
      if (getLastParam.includes("c") || getLastParam.length === 1) {
        const decodedToken: any = atob(token1);
        // Convert from UTF-8 to string
        const utf8Decoder = new TextDecoder();
        const utf8Token = utf8Decoder.decode(
          new Uint8Array([...decodedToken].map((char) => char.charCodeAt(0)))
        );
        // Split token
        jwtData = utf8Token.split("/");
      }

      const propertyIdValue = selectedProperty?.value
      const serviceIdValue = selectedService?.value
      const employeeIdValue = selectedEmployee?.value;


      if (propertyIdValue && serviceIdValue && employeeIdValue) {
        dispatch(isAllThreeFeaturesUpdate({ check: true, id: serviceIdValue }))
      }
      dispatch(
        postTipAmountApi({
          data: {
            stripe_fee: stripeFee,
            tip_amount: tipAmountForOrgFeesApis(
              tipAmount,
              applicationFee,
              data?.fee_paid_by
            ),
              application_fee: applicationFee,
              // Tipper (1): save fee note. Organization (2) or null: save null.
              application_fee_note:
                Number(data?.fee_paid_by) === 1
                  ? `application fee will be added to the transaction total.`
                  : null,
            type: `${handleSetupIntentPayload(propertyIdValue, serviceIdValue, employeeIdValue).type ? handleSetupIntentPayload(propertyIdValue, serviceIdValue, employeeIdValue).type : decodedType || intentData.type}`,
            uuid: `${handleSetupIntentPayload(propertyIdValue, serviceIdValue, employeeIdValue).uuid ? handleSetupIntentPayload(propertyIdValue, serviceIdValue, employeeIdValue).uuid : decodedUuid || intentData.uuid}`,
            note: addNote,
          },
          sessionId
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.status === 0 || res?.status === 500) {
            setPostError(res?.message);
            handleSubmitModal();
          } else {
            setApplicationFee(0);
            setStripeFee(0);
            setTipAmount("");
            navigate("/payment-confirm");
          }
        });
      setFieldError("");
    } else {
      if (fieldError?.length > 0) {
        setFieldError(fieldError);
      } else {
        if (!regex.test(tipAmount)) {
          setFieldError("Tip Amount should not be greater than 6 digits.");
        } else if (+tipAmount <= 0 && tipAmount !== "") {
          setFieldError("Tip Amount should be greater than 0.");
        } else {
          setFieldError("Please enter tip amount.");
        }
      }
    }
  };

  /**
   *
   * handle onchange get input value when user enter amount
   */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    // Check if the input value matches the regex
    setTipAmount(inputValue); // Set the tipAmount with two decimal places
    setFieldError("");
    setIsActive(null);
  };


  /**
   * Store original org-level suggested amounts when data is loaded (only if no service is selected).
   * Guard: only update state when at least one value is non-null to avoid creating a new object
   * reference that would re-trigger the suggested-amounts sync effect and cause an infinite loop.
   */
  useEffect(() => {
    if (
      orgSuggestedAmountsRef.current.suggested_amount_1 === null &&
      orgSuggestedAmountsRef.current.suggested_amount_2 === null &&
      orgSuggestedAmountsRef.current.suggested_amount_3 === null &&
      !selectedService &&
      data
    ) {
      const s1 = data?.suggested_amount_1 || null;
      const s2 = data?.suggested_amount_2 || null;
      const s3 = data?.suggested_amount_3 || null;
      // Only create a new state object when there is at least one real value;
      // setting all-null → all-null would change the reference and re-trigger downstream effects.
      if (s1 !== null || s2 !== null || s3 !== null) {
        setOrgSuggestedAmounts({
          suggested_amount_1: s1,
          suggested_amount_2: s2,
          suggested_amount_3: s3,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.suggested_amount_1, data?.suggested_amount_2, data?.suggested_amount_3, selectedService]);

  /**
   * @use_effect to calculate fee when @tipamount state updates
   */
  useEffect(() => {
    const [application_fee, stripe_fee] = calculateFee(tipAmount, data);
    setApplicationFee(application_fee ?? 0);
    setStripeFee(stripe_fee ?? 0);
  }, [tipAmount]);

  /**
   * @use_effect set homeurl and initialize cardholder name flag
   */
  useEffect(() => {
    dispatch(setHomeUrl(pathname));
    dispatch(setPrevUrl(""));
    dispatch(setShowCardholderName(true)); // Set to true to show field by default, change to false to hide
  }, [dispatch, pathname]);

  function isBase64(str: string) {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }
  /**
   * @use_effect get data of current scanned user from token
   */
  useEffect(() => {
    if (
      !(getLastParam.includes("c") || getLastParam.length === 1) &&
      getLastParam.length >= 2
    ) {
      saveTokens(token2)
      let orgIdentifier = null;
      let propertyId = null;
      let serviceIdentifier = null;
      if (getLastParam.includes("org") || getLastParam.includes("tip")) {
        orgIdentifier = token1;
      } else if (getLastParam.includes("guesty")) {
        orgIdentifier = token1;
        propertyId = token2;
      } else if (
        !getLastParam.includes("guesty") &&
        !getLastParam.includes("org") &&
        !getLastParam.includes("tip") &&
        getLastParam.length == 2
      ) {
        orgIdentifier = token1;
        serviceIdentifier = token2;
      }
      const payload: any = {
        org_identifier: orgIdentifier,
        service_identifier: serviceIdentifier,
        property_uuid: propertyId,
        url: url,
        is_customer_name: showCardholderName ? 1 : 0,
        quote_text: addQuote,
        step_1_label_text: continueButtonLabelText
      };
      // const previousId = getSessionId()
      const sessionId = createNewSession(token2);
      dispatch(setSessionId(sessionId));


      (async () => {
        const getOldTipping = await dispatch(getOldTippingUrlApi({ data: payload, sessionId }));
        const res = await getOldTipping?.payload;
        if (res?.status === 1) {
          const intent_data = {
            type: `${res?.data?.type}`,
            uuid: `${res?.data?.uuid}`,
          };
          setIntentData(intent_data);
          setIsOrgExist(true);
        } else {
          // Show toast error for all cases except when tipping is explicitly disabled (false)
          if (res?.data?.is_tipping_enabled == false) {
            setIsOrgExist(false);
          } else if (res?.data?.hasOwnProperty("error")) {
            if (res?.data?.error === "not exist") {
              navigate("/not-found");
            }
          } else {
            toast.error(res?.message, {
              autoClose: false,
            });
            setIsOrgExist(false);
          }
        }
      })();
    } else {
      if (getLastParam.includes("c") || getLastParam.length === 1) {
        saveTokens(token1)
        try {
          // First, request copy link using the full current URL
          dispatch(getCopyLink({ url, session_id: sessionId }))
            .unwrap()
            .then((copyRes: any) => {
              const copyLink = copyRes?.data?.copy_link || url;

              // Extract the last pathname segment as the Base64 token
              let base64Token = "";
              try {
                const u = new URL(copyLink);
                const parts = u.pathname.split("/").filter((p) => p !== "");
                base64Token = parts[parts.length - 1] || "";
              } catch (e) {
                const parts = (copyLink || "").split("/").filter((p: any) => p !== "");
                base64Token = parts[parts.length - 1] || "";
              }

              // Decode token from copyLink — guard against invalid base64
              let decodedUuidVal = "";
              let decodedTypeVal = "";
              try {
                const decodedToken: any = atob(base64Token);
                const utf8Decoder = new TextDecoder();
                const utf8Token = utf8Decoder.decode(
                  new Uint8Array([...decodedToken].map((char) => char.charCodeAt(0)))
                );
                const jwtData = utf8Token.split("/");
                decodedUuidVal = jwtData[0] || "";
                decodedTypeVal = jwtData[1] || "";
              } catch (e) {
                // base64 decode failed — fall through with empty values so the
                // backend call is still made and returns the appropriate error
              }
              setDecodedUuid(decodedUuidVal);
              setDecodedType(decodedTypeVal);

              // Create session from decoded UUID and persist it
              const newSessionId = createNewSession(decodedUuidVal);
              dispatch(setSessionId(newSessionId));

              // Build payload using the copy link URL exactly as received
              const paramData = {
                type: decodedTypeVal,
                uuid: decodedUuidVal,
                url: copyLink,
                is_customer_name: showCardholderName ? 1 : 0,
                quote_text: addQuote,
                step_1_label_text: continueButtonLabelText
              };

              // Proceed to fetch payment data
              dispatch(getPaymentData({ data: paramData, isCopy, session_id: newSessionId }))
                .unwrap()
                .then((res: any) => {
                  if (
                    res?.status == 0 &&
                    res?.data.hasOwnProperty("error")
                  ) {
                    if (res?.data?.error === "not exist") {
                      navigate("/not-found");
                    } else {
                      if (res?.status == 0) {
                        toast.error(res?.message);
                      }
                    }
                  }
                })
                .catch((err: any) => {
                  notifyBugsnagError(err, {
                    api: "getPaymentData",
                  });
                });
            })
            .catch((err: any) => {
              // If copy-link fails, fall back to decoding token1 directly
              let fallbackUuid = "";
              let fallbackType = "";
              try {
                const decodedToken: any = atob(token1);
                const utf8Decoder = new TextDecoder();
                const utf8Token = utf8Decoder.decode(
                  new Uint8Array([...decodedToken].map((char) => char.charCodeAt(0)))
                );
                const jwtData = utf8Token.split("/");
                fallbackUuid = jwtData[0] || "";
                fallbackType = jwtData[1] || "";
              } catch (e) {
                // token1 also invalid — proceed with empty values
              }
              setDecodedUuid(fallbackUuid);
              setDecodedType(fallbackType);
              const newSessionId = createNewSession(fallbackUuid);
              dispatch(setSessionId(newSessionId));
              const paramData = {
                type: fallbackType,
                uuid: fallbackUuid,
                url: url,
                is_customer_name: showCardholderName ? 1 : 0,
                quote_text: addQuote,
                step_1_label_text: continueButtonLabelText
              };
              dispatch(getPaymentData({ data: paramData, isCopy, session_id: newSessionId }));
            });
        } catch (error: any) {
          navigate("/not-found");
          setIsOrgExist(false);
        }
      }
    }
  }, []);


  useEffect(() => {
    if (isProperty && data?.uuid) {
      dispatch(getPropertyListApi(data.uuid))
    }
  }, [isProperty, data?.uuid]);

  // Property URL (type 2) + Select Boxes (tipping_view 1): auto-select property and load services
  useEffect(() => {
    if (data?.tipping_view == 1 && data?.type == "2" && data?.uuid) {
      setSelectedProperty({
        label: data?.property_name || data?.name || "",
        value: data.uuid,
      });
    }
  }, [data?.tipping_view, data?.type, data?.uuid, data?.property_name, data?.name]);


  useEffect(() => {
    if (propertyListData?.length > 0 && propertyListData?.length < 2) {
      setSelectedProperty({
        label: (propertyListData as any)[0]?.name,
        value: (propertyListData as any)[0]?.id
      })
    }
    const propertyData = propertyListData.map((property: any) => {
      return {
        label: property?.name,
        value: property?.id
      }
    })
    setPropertyListDropdown(propertyData)
  }, [propertyListData])


  useEffect(() => {
    const serviceData = serviceListData?.map((service: any) => {
      return {
        label: service?.service_details?.name,
        value: service?.id
      }
    })
    setServiceListDropdown([...serviceData])
  }, [serviceListData])

  useEffect(() => {
    const employeeData = employeeListData?.map((employee: any) => {
      return {
        label: employee?.property_employee_details?.name,
        value: employee?.property_employee_details?.id
      }
    })
    setEmployeeListDropdown(employeeData)
  }, [employeeListData])

  const handleChangeProperty = (e: any) => {
    const propertyValue = e;
    setSelectedProperty(propertyValue);
    setSelectedService(undefined);
    setSelectedEmployee(undefined);
    // Reset to org-level suggested amounts when property changes
    dispatch(updateSuggestedAmounts(orgSuggestedAmounts));
  };

  useEffect(() => {
    if (selectedProperty?.value) {
      dispatch(getServiceListApi(selectedProperty.value))
    }
  }, [selectedProperty]);

  const handleChangeService = (e: any) => {
    const serviceValue = e;

    // If "Select" option is chosen (empty value), set to undefined and reset to org amounts
    if (!serviceValue?.value || serviceValue?.value === '') {
      setSelectedService(undefined);
      // Reset to org-level suggested amounts
      dispatch(updateSuggestedAmounts(orgSuggestedAmounts));
    } else {
      setSelectedService(serviceValue);
    }

    dispatch(updateMediaUrl(properrtyCacheImg))
    setSelectedEmployee(undefined)

    // Reset tip amount and active state when service changes
    setTipAmount("");
    setIsActive(null);
  };

  useEffect(() => {
    if (selectedService?.value || selectedProperty?.value) {
      // Perform some action when selectedProperty changes
      dispatch(getEmployeeListApi({ propertyservice_id: selectedService?.value, property_id: selectedProperty?.value }))
    }
  }, [selectedService, selectedProperty]);


  /**
   * Update suggested amounts based on selected service.
   * Uses orgSuggestedAmountsRef (not the state value directly) so that changes to
   * orgSuggestedAmounts never re-trigger this effect — breaking the render loop.
   */
  useEffect(() => {
    const currentOrgAmounts = orgSuggestedAmountsRef.current;

    const hasSelectedService =
      selectedService &&
      selectedService.value !== undefined &&
      selectedService.value !== null &&
      selectedService.value !== '';

    if (hasSelectedService && serviceListData?.length > 0) {
      const selectedServiceData = serviceListData.find(
        (service: any) => service?.id === selectedService?.value
      );

      if (selectedServiceData?.service_details) {
        const s1 = selectedServiceData?.service_details?.suggested_amount_1;
        const s2 = selectedServiceData?.service_details?.suggested_amount_2;
        const s3 = selectedServiceData?.service_details?.suggested_amount_3;
        const serviceHasAny = !!s1 || !!s2 || !!s3;

        if (serviceHasAny) {
          dispatch(updateSuggestedAmounts({
            suggested_amount_1: s1 ?? null,
            suggested_amount_2: s2 ?? null,
            suggested_amount_3: s3 ?? null,
          }));
        } else {
          const orgHasAny =
            !!currentOrgAmounts?.suggested_amount_1 ||
            !!currentOrgAmounts?.suggested_amount_2 ||
            !!currentOrgAmounts?.suggested_amount_3;
          if (orgHasAny) {
            dispatch(updateSuggestedAmounts(currentOrgAmounts));
          } else {
            dispatch(updateSuggestedAmounts({
              suggested_amount_1: null,
              suggested_amount_2: null,
              suggested_amount_3: null,
            }));
          }
        }
      }
    } else if (!selectedService || !selectedService.value || selectedService.value === '') {
      dispatch(updateSuggestedAmounts(currentOrgAmounts));
    }
    // orgSuggestedAmounts intentionally omitted from deps — accessed via ref to prevent
    // the dispatch→Redux→render→effect loop that causes "Maximum call stack size exceeded"
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedService, serviceListData, dispatch]);

  const handleChangeEmployee = (e: any) => {
    const employeeValue = e;
    setSelectedEmployee(employeeValue); // Update the state directly here
    if (employeeValue?.label !== selectedEmployee?.label) {
      dispatch(updateMediaUrl(properrtyCacheImg))
    }
  };


  useEffect(() => {
    const empListObj: any = employeeListData?.filter((item: any) => {
      return item?.property_employee_details?.id
        == selectedEmployee?.value
    })
    if (empListObj[0]?.property_employee_details?.employee_media_details?.url) {
      dispatch(updateMediaUrl(empListObj[0]?.property_employee_details?.employee_media_details?.url))
    }
  }, [selectedEmployee])

  const decodedToken: any = "";
  // Convert from UTF-8 to string
  const utf8Decoder = new TextDecoder();
  const utf8Token = utf8Decoder.decode(
    new Uint8Array([...decodedToken].map((char) => char.charCodeAt(0)))
  );

  // Split token
  const jwtData = utf8Token.split("/");
  useEffect(() => {
    if (pathname.length <= 1) {
      window.location.href = `${process.env.REACT_APP_LANDING_URL}`;
    }
  }, []);


  const handleNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let noteText = e.target.value;

    if (noteText.length > 200) {
      setNoteError("Note should be less than 200 characters.");
      setAddNote(noteText.substring(0, 200));
    } else {
      setNoteError("");
      setAddNote(noteText);
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    let pasteText = e.clipboardData.getData("text");

    if (pasteText.length > 200) {
      setNoteError("Note should be less than 200 characters.");
      setAddNote(pasteText.substring(0, 200));
    } else {
      setNoteError("");
      setAddNote(pasteText);
    }
  };

  // Format amounts: show no decimals when .00, otherwise show two decimals
  const formatAmountDisplay = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return "";
    const num = Number(value);
    if (!Number.isFinite(num)) return "";
    return Number.isInteger(num) ? String(num) : num.toFixed(2);
  };


  // Super admin stop or paused organization
  const isAdminTippingStopped = data?.is_tipping_enabled !== undefined;
  // Org "Default tipping view" = Disabled. still rate, but cannot tip.
  const isTippingViewDisabled = Number(data?.tipping_view) === 2;
  const isTippingDisabled =
    isAdminTippingStopped || !isOrgExist || isTippingViewDisabled;

  const showRatingScreen =
    data?.is_service_score !== undefined &&
    Number(data?.is_service_score) !== 0 &&
    !hasRated;

  const handleSubmitRating = async (
    rating: number,
    comment: string,
    options?: { includeReviewUuid?: boolean }
  ) => {
    if (options?.includeReviewUuid && !review_uuid) {
      toast.error("Unable to submit feedback. Missing review reference.");
      throw new Error("Review uuid missing");
    }

    const ratingPayload = buildOrganizationRatingPayload(
      data,
      rating,
      comment,
      options?.includeReviewUuid ? review_uuid : null
    );

    if (!ratingPayload) {
      toast.error("Unable to submit rating. Missing entity details.");
      throw new Error("Rating entity details missing");
    }

    const res = await dispatch(
      submitOrganizationRatingApi({
        data: ratingPayload,
        sessionId,
      })
    ).unwrap();

    if (res?.status !== 1) {
      toast.error(res?.message || "Failed to submit rating.");
      throw new Error(res?.message || "Failed to submit rating.");
    }

    const ratingUuid =
      res?.data?.uuid ?? res?.uuid ?? res?.data?.review_uuid ?? null;
    if (ratingUuid) {
      dispatch(setReviewUuid(ratingUuid));
    }

    return res?.message || "Thank you for your feedback.";
  };

  return (
    <>
      <TipperLayout>
        <div>
          {isGetLoading ? (
            <ReactSkeleton />
          ) : showRatingScreen ? (
            <div className={styles.formContainer}>
              <Rating
                data={data}
                isTippingDisabled={isAdminTippingStopped || !isOrgExist}
                hideTipActions={isTippingViewDisabled && !isAdminTippingStopped}
                onSendTip={() => setHasRated(true)}
                onSubmitRating={handleSubmitRating}
              />
              <PaymentHeader />
            </div>
          ) : (
            <div className={styles.formContainer}>
              <form onSubmit={handleSubmit} className={styles.tipperContainer}>
                <div className={styles.tipperBottom}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "20px",
                    }}
                  >
                    <div
                      className={styles.circle}
                      style={{
                        backgroundColor: data?.theme_color,
                      }}
                    >
                      <img src={data?.employee_media ? data?.employee_media : data?.media ?? noImage} alt="" />
                    </div>
                  </div>
                  <h5 className="">
                    {data?.org_name &&
                      (data?.type == "1" || intentData.type == "1")
                      ? data?.org_name
                      : data?.property_name
                        ? data?.property_name
                        : ""}
                  </h5>

                  <p className={styles.text}>
                    {addQuote}
                  </p>
                  {data?.name && data?.type != "2" && (
                    <div className={styles.user}>
                      <span>
                        {/* {user} */}
                        {data?.name}
                      </span>
                    </div>
                  )}
                  {isProperty && propertyListData?.length > 1 && (
                    <Col xxl={12} xl={12} className="mb-2">
                      <div className={styles.addCateg}>
                        <ReactSelectField
                          name="property"
                          value={selectedProperty}
                          className="form_select"
                          options={propertyListDropdown}
                          onChange={(e) => handleChangeProperty(e)}
                          placeholder="Select Property"
                          label={
                            <>
                              Which property would you like to tip?{" "}
                              <span style={{ color: 'black' }}>(Optional)</span>
                            </>
                          }
                        />
                      </div>
                    </Col>
                  )}
                  {isService && <Col xxl={12} xl={12} className="mb-2">
                    <div className={styles.addCateg}>
                      <ReactSelectField
                        name="tipping_view"
                        className="form_select"
                        value={selectedService || null}
                        options={[{ label: 'Select', value: '' }, ...serviceListDropdown]}
                        onChange={(e) => handleChangeService(e)}
                        placeholder="Select Service"
                        label={
                          <>
                            Which service would you like to tip?{" "}
                            <span style={{ color: 'black' }}>(Optional)</span>
                          </>
                        }
                      />
                    </div>
                  </Col>}
                  {isEmployee && <Col xxl={12} xl={12} className="mb-2">
                    <div className={styles.addCateg}>
                      <ReactSelectField
                        name="tipping_view"
                        className="form_select"
                        value={selectedEmployee}
                        options={[{ label: 'Select', value: '' }, ...employeeListDropdown]}
                        onChange={(e) => handleChangeEmployee(e)}
                        placeholder="Select Employee"
                        label={
                          <>
                            Which employee would you like to tip?{" "}
                            <span style={{ color: 'black' }}>(Optional)</span>
                          </>
                        }
                      // formik={formik}
                      />
                    </div>
                  </Col>}

                  {(!!data?.suggested_amount_1 ||
                    !!data?.suggested_amount_2 ||
                    !!data?.suggested_amount_3) && (
                      <div className={styles.suggestedAmount}>
                        <h6>Amount ($)</h6>
                        <div className={styles.suggestCards}>
                          {!!data?.suggested_amount_1 && (
                            <p
                              className={
                                isActive === 1 &&
                                  data?.suggested_amount_1 === +tipAmount
                                  ? styles.differColor
                                  : ""
                              }
                              onClick={() => {
                                setFieldError("");
                                setTipAmount(`${data?.suggested_amount_1}`);
                                setIsActive(1);
                              }}
                            >
                              {
                                /* {data?.suggested_amount_1.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })} */
                                formatAmountDisplay(data?.suggested_amount_1)
                              }
                            </p>
                          )}
                          {!!data?.suggested_amount_2 && (
                            <p
                              className={
                                isActive === 2 &&
                                  data?.suggested_amount_2 === +tipAmount
                                  ? styles.differColor
                                  : ""
                              }
                              onClick={() => {
                                setFieldError("");
                                setTipAmount(`${data?.suggested_amount_2}`);
                                setIsActive(2);
                              }}
                            >
                              {
                                /* {data?.suggested_amount_2.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })} */
                                formatAmountDisplay(data?.suggested_amount_2)
                              }
                            </p>
                          )}
                          {!!data?.suggested_amount_3 && (
                            <p
                              className={
                                isActive === 3 &&
                                  data?.suggested_amount_3 === +tipAmount
                                  ? styles.differColor
                                  : ""
                              }
                              onClick={() => {
                                setFieldError("");
                                setTipAmount(`${data?.suggested_amount_3}`);
                                setIsActive(3);
                              }}
                            >
                              {
                                /* {data?.suggested_amount_3.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })} */
                                formatAmountDisplay(data?.suggested_amount_3)
                              }
                            </p>
                          )}
                        </div>
                      </div>
                    )}
                  <div className={styles.tipperRightForm}>
                    {" "}
                    <label className="test" htmlFor="">
                      {!!data?.suggested_amount_1 ||
                        !!data?.suggested_amount_2 ||
                        !!data?.suggested_amount_3
                        ? "Custom amount ($)"
                        : "Amount ($)"}
                    </label>
                    <br />
                    <div className={styles.search}>
                      {/* {dollar} */}
                      <NumericFormat
                        allowNegative={false}
                        style={{
                          cursor: isTippingDisabled ? "not-allowed" : "text",
                        }}
                        disabled={isTippingDisabled}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        type="text"
                        placeholder="Enter Amount"
                        // maxLength={9}
                        onChange={(e) => handleChange(e)}
                        value={tipAmount}
                      />
                    </div>
                    {fieldError && (
                      <span className={styles.error} style={{ textAlign: 'start', display: 'flex', width: '100%', justifyContent: 'start', marginTop: '5px' }}>{fieldError}</span>
                    )}
                    {/* {tipAmount && +applicationFee >= 0 && (
                      <p>
                        {eyeIcon} ${(+applicationFee).toFixed(2)} application
                        fee will be {data?.fee_paid_by == 1 ? `added to the transaction total.` : `deducted from this amount.`}
                      </p>
                    )} */}
                      {tipAmount &&
                      +applicationFee >= 0 &&
                      data?.fee_paid_by === 1 && (
                        <p>
                          {eyeIcon} ${(+applicationFee).toFixed(2)} application
                          fee will be added to the transaction total.
                        </p>
                      )}
                    {
                      data?.show_notes === 1 && <div className="my-2">
                        <label htmlFor="note">
                          Note <span>(Optional)</span>
                        </label>
                        <input
                          type="text"
                          id="note"
                          disabled={isTippingDisabled}
                          onPaste={handlePaste}
                          onChange={(e) => {
                            // setError("");
                            handleNoteChange(e);
                          }}
                          value={addNote}
                          placeholder="Enter note"
                          className={styles.email}
                          style={{
                            marginBottom: "2px",
                            cursor: isTippingDisabled ? "not-allowed" : "text",
                          }}
                        />
                        {noteError && <p style={{ color: '#d22b2b ', fontSize: '12px', fontWeight: 500, marginTop: '5px' }}>{noteError}</p>}
                      </div>
                    }
                  </div>

                  {data?.is_tipping_enabled !== undefined ? (
                    <div className="tippingEnabled">
                      {data?.message ? data?.message : ""}
                    </div>
                  ) : isTippingViewDisabled ? null : (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        marginTop: "15px",
                        padding: "0px 18px",
                      }}
                    >
                      <ThemeButton
                        type="submit"
                        loading={postTipAmount.isPostDataLoading}
                        disabled={!isOrgExist || noteError !== ''}
                      >
                        {continueButtonLabelText}
                      </ThemeButton>
                      <ConfirmationModal
                        handleToggle={handleSubmitModal}
                        icon={oops}
                        title={postError}
                        desc={"You have not been charged."}
                        show={showSubmitModal}
                      />
                    </div>
                  )}
                </div>
              </form>
              <PaymentHeader />
            </div>
          )}
          <PaymentFooter />
        </div>
      </TipperLayout>
    </>
  );
};
export default TippingPayment;